import { RemixBrowser } from '@remix-run/react';
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { createStore } from 'jotai';
import { AtomFamilies, Atoms } from 'shared/atoms';

import 'core-js/es/object/has-own';

declare global {
  interface Window {
    store: ReturnType<typeof createStore>;
    atoms: any;
    atomFamilies: any;
  }
}

// TODO load all polyfills
// import('intersection-observer');

// init window jotai store
window.store = createStore();
window.atoms = Atoms;
window.atomFamilies = AtomFamilies;

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
